import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Landing from './components/Landing';
import AboutMe from './components/AboutMe';
import Services from './components/Services';
import MyPortfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import ContactMe from './components/ContactMe';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function Portfolio() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace('#', '');
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash]);

  return (
    <div className="Portfolio">
      <Helmet>
        <title>Nemwel Boniface — Software Developer</title>
        <meta name="description" content="Portfolio of Nemwel Boniface: full-stack developer specializing in Ruby on Rails and React. View services, projects, testimonials, and contact details." />
        <link rel="canonical" href="https://nemwelboniface.netlify.app/" />
      </Helmet>
      <Navbar />
      <Landing />
      <AboutMe />
      <Services />
      <MyPortfolio />
      <Testimonials />
      <Blog />
      <ContactMe />
      <Footer />
    </div>
  );
}

export default Portfolio;
